import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.F7vuwsVv9S9mv_maYejj5P5zjb4ckvx_sdoPVNj36lbdqioy5_qg1fWkD25f0vWUpzvCD9mcng54JX2Y87Q57A3Y0j6eIyL8UAhPhk3Zhn4GiY3a1pGWosnRtkMQYKtxN-ohTzIIGm1BHtTVAbMKShPzq2y_vfYLE8F0xAyFKhToDmOEohbpir2zmxHFBZRK5rizEhhPyVAwGZPPPfwiAw-JCJQ8uscvJvJav-mUGTZL6nbus3ot0KSY370WE1djNC0dCVGEwRz-NnVW397r5GoB1wBqGrBOFIPxsbKQXn7crUTcH8EtTsVE5ZYcrL0VpogvNhYILj4IriBNcxr4NPBUVyu8YuicuA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-10-05T21:12:06.912577Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.F7vuwsVv9S9mv_maYejj5P5zjb4ckvx_sdoPVNj36lbdqioy5_qg1fWkD25f0vWUpzvCD9mcng54JX2Y87Q57A3Y0j6eIyL8UAhPhk3Zhn4GiY3a1pGWosnRtkMQYKtxN-ohTzIIGm1BHtTVAbMKShPzq2y_vfYLE8F0xAyFKhToDmOEohbpir2zmxHFBZRK5rizEhhPyVAwGZPPPfwiAw-JCJQ8uscvJvJav-mUGTZL6nbus3ot0KSY370WE1djNC0dCVGEwRz-NnVW397r5GoB1wBqGrBOFIPxsbKQXn7crUTcH8EtTsVE5ZYcrL0VpogvNhYILj4IriBNcxr4NPBUVyu8YuicuA'

// {
//   "access_token": "v2.local.dnjyJ0Y668O7nvp5IC9Y6wdj114d3kWrV9w-q7cbKswZcGyo7RIzZps_BT82Ae-Bq4aF2CaME8UfzY-96NExQDQXSz1kR7BZJbep7ID3Or42UqqdivpQ0vekezqTaCApFIdrNuaxutVMR7uDRgcZ2LvbwraQtY6Cmv_88SoREVlAzEosrLpylHdBNDZmIb8QYfUk7vQ9K-39fwHVsUlQHwfBo32hIOzwrfjGQV7xR_V6uo_rcGmx1luSpeijdwT7ZG3_d4_4UEgvLvkb0NNSCeWm0cc0QVR6Po9Boy8qAbjI89Qvk6o-pfka4-2zQxpH1CmC0gd9wDzlmFN6GuPO0xzoq6Jp",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-10-05T21:12:07.222667Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.dnjyJ0Y668O7nvp5IC9Y6wdj114d3kWrV9w-q7cbKswZcGyo7RIzZps_BT82Ae-Bq4aF2CaME8UfzY-96NExQDQXSz1kR7BZJbep7ID3Or42UqqdivpQ0vekezqTaCApFIdrNuaxutVMR7uDRgcZ2LvbwraQtY6Cmv_88SoREVlAzEosrLpylHdBNDZmIb8QYfUk7vQ9K-39fwHVsUlQHwfBo32hIOzwrfjGQV7xR_V6uo_rcGmx1luSpeijdwT7ZG3_d4_4UEgvLvkb0NNSCeWm0cc0QVR6Po9Boy8qAbjI89Qvk6o-pfka4-2zQxpH1CmC0gd9wDzlmFN6GuPO0xzoq6Jp'

// {
//   "access_token": "v2.local.Sw8jOTW_djuKA_lj2mvUjdRBG1gbL0024bXEBtpZvm5nwsoQ9fyef_rxqvXpGFTT7GP6JJ4_ooe2WqOx2VxeIvmjkq7VF0nqRSFO6WzybNygmU66HzpbieluaKq1ARyZEp1QRIIttMc8fVV0BRqexGMKx7AvOGKTCZPZg3vf-Q74P-NjR2LYsg5ZZmlwacNtvevcYnwgYyv3pJwonJxvkutXX4M-assN3uddrr6AC7Az0Q9oK3c0x67f5kmn8KhKpGKLcHJtudTTMQxu9JPhH1I5KXhKEXPWR5eidlpBEhEDG4GZ9f0SXYsDoYui2vJCVXTMYq6Qktgxo8fdOdnQy9JMgCg",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-10-05T21:12:07.558536Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.Sw8jOTW_djuKA_lj2mvUjdRBG1gbL0024bXEBtpZvm5nwsoQ9fyef_rxqvXpGFTT7GP6JJ4_ooe2WqOx2VxeIvmjkq7VF0nqRSFO6WzybNygmU66HzpbieluaKq1ARyZEp1QRIIttMc8fVV0BRqexGMKx7AvOGKTCZPZg3vf-Q74P-NjR2LYsg5ZZmlwacNtvevcYnwgYyv3pJwonJxvkutXX4M-assN3uddrr6AC7Az0Q9oK3c0x67f5kmn8KhKpGKLcHJtudTTMQxu9JPhH1I5KXhKEXPWR5eidlpBEhEDG4GZ9f0SXYsDoYui2vJCVXTMYq6Qktgxo8fdOdnQy9JMgCg'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
